export const FETCH_ADMIN_ROIS = 'src/AdminRoiList/FETCH_ADMIN_ROIS';
export const FETCH_ADMIN_ROIS_SUCCESS =
	'src/AdminRoiList/FETCH_ADMIN_ROIS_SUCCESS';
export const FETCH_ADMIN_ROIS_ERROR =
	'src/AdminRoiList/FETCH_ADMIN_ROIS_ERROR';

export const ADMIN_LINK_ROI = 'src/AdminRoiList/ADMIN_LINK_ROI';
export const ADMIN_LINK_ROI_SUCCESS =
	'src/AdminRoiList/ADMIN_LINK_ROI_SUCCESS';
export const ADMIN_LINK_ROI_ERROR = 'src/AdminRoiList/ADMIN_LINK_ROI_ERROR';

export const ADMIN_REVOKE_ROI = 'src/AdminRoiList/ADMIN_REVOKE_ROI';
export const ADMIN_REVOKE_ROI_SUCCESS =
	'src/AdminRoiList/ADMIN_REVOKE_ROI_SUCCESS';
export const ADMIN_REVOKE_ROI_ERROR =
	'src/AdminRoiList/ADMIN_REVOKE_ROI_ERROR';

export const APPROVE_ROI_MATCH = 'src/AdminRoiList/APPROVE_ROI_MATCH';
export const APPROVE_ROI_MATCH_SUCCESS =
	'src/AdminRoiList/APPROVE_ROI_MATCH_SUCCESS';
export const APPROVE_ROI_MATCH_ERROR =
	'src/AdminRoiList/APPROVE_ROI_MATCH_ERROR';

export const REJECT_ROI_MATCHES = 'src/AdminRoiList/REJECT_ROI_MATCHES';
export const REJECT_ROI_MATCHES_SUCCESS =
	'src/AdminRoiList/REJECT_ROI_MATCHES_SUCCESS';
export const REJECT_ROI_MATCHES_ERROR =
	'src/AdminRoiList/REJECT_ROI_MATCHES_ERROR';
